class OurWorks {
  constructor() {
    this.workItems = document.querySelectorAll('[data-work]');
    this.images = document.querySelectorAll('[data-work-main-image]');
    this.container = document.querySelector('[data-our-works-container]');
    this.init();
    this.initWorkHover();
  }

  init() {
    // Set first image as active by default
    if (this.images.length > 0) {
      this.images[0].classList.add('work__grid-media--active');
    }
  }

  initWorkHover() {
    if (this.workItems.length === 0) return;

    this.workItems.forEach(workItem => {
      const activateImage = () => {
        this.workItems.forEach(sib => sib.classList.remove("work__item--active"));
        workItem.classList.add("work__item--active");

        const targetId = workItem.getAttribute("data-work");
        const targetImg = document.querySelector(`[data-work-main-image="${targetId}"]`);

        if (targetImg) {
          this.images.forEach(img => img.classList.remove("work__grid-media--active"));
          targetImg.classList.add("work__grid-media--active");
        }
      };

      workItem.addEventListener("mouseenter", activateImage);
      
      // Handle clicks - if no link, clicking just activates the image
      const link = workItem.querySelector('.our-works__item-link');
      if (!link) {
        workItem.addEventListener("click", activateImage);
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new OurWorks();
  });
} else {
  new OurWorks();
}
